
import { BaseAjaxSave } from "../../../../assets/js/common/shared_service";

export default class CreateDeliveryNote{

    constructor(){
        this.deliveryNoteForm = document.querySelector('#deliveryNoteCreateForm');
        if(!this.deliveryNoteForm) return;
        this.events();
    }

    events(){
        this.deliveryNoteForm.addEventListener('submit', (event) => {
            BaseAjaxSave(event);
        });
    }

} 